import { Box, alpha, useTheme } from '@mui/material'
import { InfoOutlined } from '@mui/icons-material'

// Shown while "Keep me logged in" is ticked
const PersistLoginAlert = ({ sx }) => {
  const theme = useTheme()
  const info = theme.palette.info.main

  return (
    <Box
      role="note"
      sx={{
        display: 'flex',
        gap: 1.25,
        p: 1.5,
        borderRadius: 2,
        fontSize: '0.8rem',
        lineHeight: 1.5,
        color: theme.palette.text.secondary,
        backgroundColor: alpha(info, 0.08),
        border: `1px solid ${alpha(info, 0.3)}`,
        '& strong': { color: theme.palette.text.primary, fontWeight: 600 },
        ...sx,
      }}
    >
      <InfoOutlined sx={{ fontSize: 18, color: info, mt: '1px', flexShrink: 0 }} />
      <Box>
        <strong>Keep me logged in</strong> asks you to log in less often on this device.
        Use it only on <strong>trusted devices</strong>.
      </Box>
    </Box>
  )
}

export default PersistLoginAlert
